<template>
  <v-row>
    <v-col>
      <v-autocomplete
        label="First party"
        :loading="associatedFirstPartiesLoading"
        :items="firstParties"
        item-text="name"
        item-value="id"
        return-object
        :value="selectedAccount"
        @change="onChangeAccount"
      />
      <v-autocomplete
        label="Signatory"
        :loading="signatoriesLoading"
        :disabled="signatoriesLoading"
        multiple
        chips
        deletable-chips
        :items="signatories"
        item-text="name"
        item-value="id"
        return-object
        :value="selectedSignatories"
        @change="onChangeUsers"
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'SignatorySelect',
  props: {
    selectedAccount: { type: String, default: null },
    selectedSignatories: { type: Array, default: () => [] }
  },
  computed: {
    firstParties() {
      if (this.associatedFirstPartiesLoading || this.appUserLoading) {
        return []
      }
      const { accountId, accountShortName } = this.appUser
      return [{ id: accountId, name: accountShortName }, ...this.associatedFirstParties]
    }
  },
  watch: {
    selectedAccount(newVal) {
      if (newVal) {
        this.$store.dispatch('get_signatories', this.selectedAccount)
      }
    }
  },
  mounted() {
    if (this.selectedAccount) {
      this.$store.dispatch('get_signatories', this.selectedAccount)
    }
  },
  beforeCreate() {
    this.mapStates([
      'appUser',
      'associatedFirstParties',
      'associatedFirstPartiesLoading',
      'signatories',
      'signatoriesLoading'
    ])
    this.$store.dispatch('get_associatedFirstParties')
  },
  methods: {
    async onChangeAccount(value) {
      this.onChangeUsers([], value ? value.id : null)
    },
    onChangeUsers(signatories, accountId = this.selectedAccount) {
      const party = {
        accountId,
        signatories: signatories.map(({ id, name }) => ({ id, name }))
      }
      this.$emit('change', party)
    }
  }
}
</script>
